import type { CSSProperties } from 'react';
import { ICONES, type NomIcona } from './icones';

export type { NomIcona };

/**
 * Icona SVG del sistema de disseny (estil SF Symbols, traç 1.7, extrems arrodonits).
 * La mida per defecte és 1em: hereta el `font-size` del context o es fixa amb `mida`.
 */
export function Icona({
  nom,
  mida,
  className,
  style,
  titol,
}: {
  nom: NomIcona;
  mida?: number;
  className?: string;
  style?: CSSProperties;
  titol?: string;
}) {
  return (
    <svg
      className={`icon${className ? ` ${className}` : ''}`}
      viewBox="0 0 24 24"
      style={mida ? { fontSize: mida, ...style } : style}
      aria-hidden={titol ? undefined : true}
      role={titol ? 'img' : undefined}
      aria-label={titol}
      focusable="false"
      data-icona={nom}
      dangerouslySetInnerHTML={{ __html: ICONES[nom] }}
    />
  );
}
